import { render, staticRenderFns } from "./StateCategory.vue?vue&type=template&id=cc72c670"
import script from "./StateCategory.vue?vue&type=script&lang=js"
export * from "./StateCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports